import AnchorTag from '@/components/AnchorTag'
import DocumentTemplate from '@/components/ui/document-template/DocumentTemplate'

/*
	In order to handle special characters, we need to use the unicode escape sequence:
	\n - Line Feed
	\u00A0 - No-Break Space
	...
*/
const technologyContent = [
	{
		title: 'Standard',
		text: <p>It’s a CAP20 token. Exactly like ERC20 but different because it's on the Chiliz Chain</p>
	},
	{
		title: 'Supply',
		text: (
			<p>
				A lot. Tastiest peppers aren’t the hippy organic stuff, it's those big GMO suckers stuffed to the brim
				with wacky chemicals. Let’s call it like 1,000,000 <AnchorTag text={'PEPPER'} /> for every{' '}
				<AnchorTag text={'CHZ'} /> in circulation (Original Circulation 8,888,888,888 CHZ) or, to spicify,
				8,888,888,888,000,000 <AnchorTag text={'PEPPER'} />.
			</p>
		)
	},
	{
		title: 'Minting',
		text: (
			<p>
				Fair launch. Aidrops and Harvesting; no one’s gettin’ a bag of fresh spice otherwise. Whoever wants to
				farm the <AnchorTag text={'PEPPER'} /> contract, farms.
			</p>
		)
	},
	{
		title: 'Ok so how do I get some?',
		text: (
			<p>
				Be cool, or more accurately hot - like in a metaphorical way where “hot” is measured by how much you
				care about our ecosystem & participate in it.
			</p>
		)
	},
	{
		title: 'Ok so specifically?',
		text: (
			<p className="pl-4 leading-7">
				<span>
					• Hold 100+ CHZ in a self-hosted wallet on the Chiliz Chain (the PEPPER can reach you so not on a
					USB)
				</span>
				<br />
				<span>
					• Stake 100+ CHZ with any Chiliz Chain Main Validator via the <AnchorTag text={'Governance'} /> Dapp
				</span>
				<br />
				<span>• Be cool</span>
				<br />
			</p>
		)
	}
]

const launchPeppernomics = [
	{
		text: <p>PEPPER supply will be distributed/minted via 2 methods:</p>
	},
	{
		title: 'Airdrop',
		text: (
			<p>
				• Approximately 30% of the <AnchorTag text={'PEPPER'} /> supply will be airdropped to holders and
				stakers. <br />
				(Peppers were never famous for their math skills, so don’t quote us on the 30% it could be 32.888%){' '}
				<br />
				• 150,000 <AnchorTag text={'PEPPER'} /> will be airdropped for every 1 CHZ (on Chiliz Chain) held in a
				wallet or staked on our <AnchorTag text={'Governance'} />. You must own or have staked at least 100+ CHZ
				to be eligible. <br />
				• There will be multiple hot and spicy airdrops, so the above numbers are for one airdrop (!!!) <br />
			</p>
		)
	},
	{
		title: 'Farming',
		text: (
			<p>
				• The remaining approximate 70% of the <AnchorTag text={'PEPPER'} /> supply will be available for
				harvesting. <br />
				• 250,000 <AnchorTag text={'PEPPER'} /> will be harvested for every 1 CHZ (on Chiliz Chain) staked on
				Main Validators on the Chiliz Chain <AnchorTag text={'Governance'} />. You must have staked at least
				100+ CHZ to be eligible. <br />• Harvesting will be available once a day, and the farming season will
				last 3 months, or until all the crops (supply) are harvested!!! Harvest daily throughout the farming
				season and you’ll have enough <AnchorTag text={'PEPPER'} /> to fill the largest football stadium! <br />
			</p>
		)
	},
	{
		title: 'Reasons to get PEPPER',
		text: (
			<p>
				None really. This is a pretty blatant attempt to ride the coattails of Community Tokens Summer 2024.
				Every chain seems to have one blowing up. This one just isn’t a dog coin because we’re pretty boxed into
				the whole spicy fruit/ vegetable thing. And by the way, that “fruit/ vegetable” wording - it’s not just
				because we can’t decide whether peppers are fruits or vegetables. The whole world can’t. Botanically
				they’re fruits - actually more technically they’re berries (which is a bit of a mindf$*k) - but people
				have used them as if they’re veggies when cooking for so long there’s this broad misconception that they
				actually are literal veggies. They’re not though <br />
				<br />
				Anyways, don’t end up buying this thing. There’s no reason for it to exist & the only utility it will
				ever have is for the gang running it’s X account; they’ll have a captive audience to shoot off some
				random AI platform filtered “pepper” bits to, because secretly some of them wanted to become stand-ups
				but never had the guts or talent to pursue their dreams - so they’re open to voicing community tokens on
				the internet for cold hard centralized FIAT cash instead.
			</p>
		)
	}
]

const disclaimerContent = [
	{
		text: (
			<p>
				Before you dive into the spicy world of <AnchorTag text={'PEPPER'} />, we've got some important tidbits
				to share. Don’t APE yet, anon! Remember, while laughter is the best medicine, taking investment advice
				from a chili pepper might not be. So, buckle up for a disclaimer that's as flavorful as a spicy
				jalapeño.
			</p>
		)
	},
	{
		title: 'Spicy, Not Financially Advisable',
		text: (
			<p>
				The <AnchorTag text={'PEPPER'} /> coin is a digital high-five in the crypto world—a community token with
				the spirit of a chili in a fiesta, designed for chuckles, not checkbooks. Its utility in the traditional
				sense is as present as a snowman in the Sahara. In other words, zilch, nada, zero. We're here for the
				community, not the money. Seriously, it hasn’t inherent value, like, none.
			</p>
		)
	},
	{
		title: 'Volatility Is Our Middle Name',
		text: (
			<p>
				Just like the Scoville scale, the value of <AnchorTag text={'PEPPER'} /> can go up and down faster than
				a jalapeño on a roller coaster. It's speculative, unpredictable, and not for the faint of heart (or
				wallet). Consider this coin a dare of the crypto world—exciting, but not for everyone. It might very
				well go to zero.
			</p>
		)
	},
	{
		title: 'No Tears Shed Over Spilled Pepper',
		text: (
			<p>
				In the off-chance that <AnchorTag text={'PEPPER'} /> becomes the next big community token sensation, or
				conversely, if it fizzles out like a damp match, we’re all in this for the fun. Allocate resources
				responsibly and by that is, the amount that you are willing to (likely) lose.
			</p>
		)
	},
	{
		title: 'Regulatory Salsa',
		text: (
			<p>
				As the crypto market is as regulated as a free-for-all taco stand, jurisdictions around the globe are
				still figuring out how to handle community-tokens like <AnchorTag text={'PEPPER'} />. It's your job to
				stay informed and comply with local laws, whether you're trading <AnchorTag text={'PEPPER'} /> from the
				beaches of Cancun or the streets of Bangkok. Please make sure your local food safety (legal and
				regulatory) guidelines allow for the possession and trading of community-seasoned tokens like{' '}
				<AnchorTag text={'PEPPER'} />
				..
			</p>
		)
	},
	{
		title: 'Allergic Reactions (Liability)',
		text: (
			<p>
				Just as some people can't handle their spice, <AnchorTag text={'PEPPER'} /> might not be for everyone.
				The creators, developers, and promoters of <AnchorTag text={'PEPPER'} /> cannot be held liable for any
				tears, laughter, or financial indigestion that may occur from participating in this peppery endeavor.
				Engage at your own risk, and remember: no one forced you to eat the pepper. No-one “owns” the idea of{' '}
				<AnchorTag text={'PEPPER'} />, it is what it is, a community token. Nothing more, nothing less.
			</p>
		)
	},
	{
		title: 'Legal Recipe',
		text: (
			<p>
				While we’ve seasoned this disclaimer with humor, the essence is serious. <AnchorTag text={'PEPPER'} />{' '}
				is a creation for entertainment and should be approached with the same caution one would use when
				handling a Carolina Reaper—carefully, and with a good sense of humor.
			</p>
		)
	},
	{
		text: (
			<p>
				So there you have it, anon. If you choose to partake in the <AnchorTag text={'PEPPER'} /> journey,
				you're acknowledging the spice of life (and crypto) with all its ups and downs. Remember, getting or
				holding <AnchorTag text={'PEPPER'} /> is like adding hot sauce to your meal—a little can go a long way,
				and it's not for everyone. Enjoy responsibly and keep the memes coming!
			</p>
		)
	}
]

const WhitePepper = () => (
	<DocumentTemplate
		title="Whitepepper"
		contentBuckets={[
			{
				bucketTitle: 'Technology',
				className: 'bg-green-10',
				content: technologyContent
			},
			{
				bucketTitle: 'Launch Peppernomics',
				className: 'bg-green-20',
				content: launchPeppernomics
			},
			{
				bucketTitle: 'Disclaimer',
				className: 'bg-green-10',
				content: disclaimerContent
			}
		]}
	/>
)

export default WhitePepper
